import { Flex } from "@chakra-ui/react";
import RoundButton from "src/components/RoundButton";
import usePrevious from "src/hooks/usePrevious";
import { ReactComponent as PauseIcon } from "./pause.svg";
import { ReactComponent as PlayIcon } from "./play.svg";

export default function ControlButton({ status, setStatus, play, pause }) {
  let controlButton;
  const previousStatus = usePrevious(status);

  if (status === "resting") {
    controlButton = {
      type: "play",
      onClick: () => setStatus("loading"),
      in: true
    };
  } else if (status === "paused") {
    controlButton = {
      type: "play",
      onClick: () => {
        setStatus("playing");
        play();
      },
      in: true
    };
  } else if (status === "loading" && previousStatus === "resting")
    controlButton = {
      type: "pause",
      onClick: () => setStatus("resting")
    };
  else if (status === "loading" || status === "playing") {
    controlButton = {
      type: "pause",
      onClick: () => {
        setStatus("paused");
        pause();
      }
    };
  }
  return (
    <Flex flexDirection="column" alignItems="center">
      <RoundButton
        onClick={controlButton?.onClick}
        icon={controlButton?.type === "pause" ? PauseIcon : PlayIcon}
        iconFill="white"
        iconSize="32px"
        size="32px"
      />
    </Flex>
  );
}
